/* eslint-disable
    consistent-return,
    react/prop-types
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import React from 'react';
import createReactClass from 'create-react-class';
import * as StepConstants from 'notebook/protocols/StepConstants';

const {EditorKey} = StepConstants;

import PropTypes from 'prop-types';

import EditableComponent from 'notebook/mediocre/core-ui/EditableComponent';
import EditableList from 'notebook/mediocre/selection/text/EditableListMixin';
import * as selutil from 'notebook/mediocre/selection/text/SelUtil';
import wyciwyp from 'notebook/mediocre/clipboard/wyciwyp';

const MAX_TITLE_LENGTH = 255;

export default createReactClass({
  propTypes: {
    cid: PropTypes.string.isRequired,
    protocol: PropTypes.object.isRequired,
    jumpTo: PropTypes.func.isRequired,
    updateProtocol: PropTypes.func, // omitted if locked
    spellCheck: PropTypes.bool.isRequired,
  },
  mixins: [EditableList],

  getInitialState() {
    return {
      index: 0,
    };
  },

  updateHandler(e) {
    const {text} = e;
    if (text.length <= MAX_TITLE_LENGTH) {
      this.props.updateProtocol({name: text});
      return this.props.requestSelection({selection: selutil.getSelectionIndices()});
    } else if (this._origSelection != null) {
      // forceContentEditableUpdate to reset component to show original text
      this.refs.contentEditable.forceContentEditableUpdate();
      return this.props.requestSelection({selection: this._origSelection});
    }
  },

  pasteHandler(e) {
    const {before, after, originalEvent} = e;
    const parts = wyciwyp.processClipboard(originalEvent.clipboardData);
    const allowedPasteLength = MAX_TITLE_LENGTH - before.length - after.length;
    const pasteText = parts
      .map((part) => part.text)
      .join(' ')
      .slice(0, allowedPasteLength);
    const text = before + pasteText + after;
    const pos = text.length - after.length;

    this.props.updateProtocol({name: text});
    this.props.requestSelection({selection: {cid: this.props.cid, start: pos, end: pos}});
  },

  moveHandler(e) {
    const {up, beginning} = e;
    if (!up) {
      this.clearSelection();
      const location = beginning ? 'start' : 'end';
      this.props.jumpTo({section: EditorKey.INTRO, location, row: 'first'});
    }
  },

  keyDownHook() {
    this._origSelection = selutil.getSelectionIndices();
  },

  render() {
    return (
      <h1
        className={classNames({
          'mediocre-titleEditor': true,
          'is-locked': this.props.locked,
        })}
      >
        <EditableComponent
          ref="contentEditable"
          cid={this.props.cid}
          text={this.props.protocol.name}
          index={this.state.index}
          moveHandler={this.moveHandler}
          updateHandler={this.updateHandler}
          pasteHandler={this.pasteHandler}
          storeState={this.props.storeState}
          restoreState={this.props.restoreState}
          keyDownHook={this.keyDownHook}
          locked={this.props.locked}
          spellCheck={this.props.spellCheck}
          allowRichText={false}
          allowMultiline={false}
        />
      </h1>
    );
  },
});
